<template>
    <b-modal
        :id="'product-reviews-modal' + product.ASIN"
        class="main-modal product-reviews-modal"
        ref="showEnterSuccessModal"
        size="lg"
        ok-only
        :ok-title="'Done'"
    >
        <div slot="modal-header-close">
            (Times)
        </div>

        <div class="d-block">

            <div class="row">
                <div class="col-md-12">
                    <div class="product-reviews-modal__wrapper">
                        <iframe v-if="iframeUrl" class="product-reviews-modal__wrapper__iframe" :src="iframeUrl" frameborder="0" width="100%"></iframe>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'product-reviews-modal',
    props: {
        product: {
            type: Object,
            required: true
        },
    },
    data () {
        return {
            iframeUrl: null
        }
    },
    methods: {
    },
    mounted () {
        this.$root.$on('bv::show::modal', (id) => {
            if (id === 'product-reviews-modal' + this.product.ASIN) {
                this.iframeUrl = this.product.CustomerReviews.IFrameURL
            }
        })
    },
    computed: {
    }
}
</script>

<style lang="scss" scoped>
    @import '~@/assets/css/components/_variables.scss';

    .product-reviews-modal {
        width: 100%;
        max-width: 100%;

        &__wrapper {
            overflow: auto;
            -webkit-overflow-scrolling: touch;
            width: 100%;
            height: 500px;

            &__iframe {
                border: 1px solid $grey;
                height: 500px;
                padding: 10px 10px 0 10px;
                box-shadow: $box-shadow;
                border-radius: 5px;
            }
        }
    }
</style>
